import React from 'react'
import PropTypes from 'prop-types'
import firebase from 'firebase'
import { dataAppDatabase, locale } from '../../../index'
import ResidencyFluorTable from './ResidencyFluorTable/ResidencyFluorTable'
import FluorAdministrationByAge from './FluorAdministrationByAge/FluorAdministrationByAge'
import Loading from '../../common/Loading/Loading'

export default class FluorInfo extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      patient: undefined,
      patientData: undefined,
      patientId: undefined
    }
    this.getPatient = this.getPatient.bind(this)
    this.handleResidencyMarksChanges = this.handleResidencyMarksChanges.bind(this)
    this.handleFluorAdministrationChanges = this.handleFluorAdministrationChanges.bind(this)
    this.getConfiguration = this.getConfiguration.bind(this)
  }

  handleResidencyMarksChanges (newMark) {
    const rootRef = dataAppDatabase.ref()
    const patientRef = rootRef.child('riso').child('patientsByCountry').child(locale).child(this.state.patientId).child('data').child('residencyFluorMarks')
    patientRef.push(newMark)
  }

  handleFluorAdministrationChanges (newAdministration) {
    const rootRef = dataAppDatabase.ref()
    const patientRef = rootRef.child('riso').child('patientsByCountry').child(locale).child(this.state.patientId).child('data').child('fluorByAge')
    patientRef.push(newAdministration)
  }

  getConfiguration () {
    const rootRef = firebase.database().ref()
    const config = rootRef.child('riso').child('configuration')
    config.on('value', dataSnapshot => {
      this.setState({
        config: dataSnapshot.child('fluor').val()
      })
    })
  }

  getPatient (patientNumber) {
    const rootRef = dataAppDatabase.ref()
    const patientRef = rootRef.child('riso').child('patientsByCountry').child(locale)
    let patientData = null
    let patientId = null
    let patient = null
    patientRef.on('value', snapshot => {
      snapshot.forEach((childSnap) => {
        if (childSnap.val().patientNumber.toString() === patientNumber) {
          patientData = childSnap.val().data
          patient = childSnap.val()
          patientId = childSnap.key
          this.props.setPatientId(childSnap.val().patientNumber)
        }
      })
      if (patientData !== null) {
        this.setState({
          patient: patient,
          patientData: patientData || {},
          patientId: patientId
        })
      }
    })
  }

  componentWillMount () {
    this.getConfiguration()
    this.getPatient(this.props.match.params.patientId)
  }

  render () {
    return (
      <div className='container'>
        {this.state.patientData && this.state.config
          ? <div>
            <ResidencyFluorTable config={this.state.config['fluorOfResidency']} currentPatient={this.state.patient} handleChange={this.handleResidencyMarksChanges}
              elements={this.state.patientData.residencyFluorMarks} />
            <FluorAdministrationByAge config={this.state.config['fluorAdministration']}
              handleChange={this.handleFluorAdministrationChanges}
              elements={this.state.patientData.fluorByAge} />
          </div>
          : <Loading />
        }
      </div>
    )
  }
}

FluorInfo.propTypes = {
  setPatientId: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/components/general/FluorInfo/FluorInfo.js